module.exports = __webpack_public_path__ + "static/alfred-lin-ca004bd7f9a03de37c108b4863f035fa.jpg";